import React, { Component, useState } from "react";
// components
import PageTitle from "../../components/PageTitle/PageTitle";
import Cookies from "universal-cookie";
import LoadingOverlay from "react-loading-overlay";
import Table from "../../widgets/tables/Table";
import WaitDialog from "../../widgets/WaitDialog";
import SendMailWidget from "../../widgets/SendMailWidget";
import SendNotificationWidget from "../../widgets/SendNotificationWidget";
import GetInsegnanti from "../../services/getInsegnanti";
import DeleteInsegnante from "../../services/deleteInsegnante";
import Utils from "../../utils/utils";
import SelectPdfDatesWidget from "../../widgets/SelectPdfDatesWidget";
import FusioneWidget from "../../widgets/FusioneWidget";
import addGruppoInsegnanti from "../../services/addGruppoInsegnanti";
import deleteGruppoInsegnanti from "../../services/deleteGruppoInsegnanti";
import getGruppiInsegnanti from "../../services/getGruppiInsegnanti";
import addNotification from "../../services/addNotification";
import sendMail from "../../services/sendMail";
import getSetting from "../../services/getSetting";
import saveFile from "../../services/saveFile";
import addUtente from "../../services/addUtente";
import Button from "../../widgets/Button";
import generateExcel from "../../services/generateExcel";
import getPresenzeCorso from "../../services/getPresenzeCorso";
import getChiusura from "../../services/getChiusura";
import moment from "moment";
import getPresenze from "../../services/getPresenze";
import Constants from "../../utils/consts";
import getLezioni from "../../services/getLezioni";
import WaitDialogFileDownload from "../../widgets/WaitDialogFileDownload";
import getTariffeInsegnanti from "../../services/getTariffeInsegnanti";
import getMaterie from "../../services/getMaterie";
import deleteMateria from "../../services/deleteMateria";

export default class Materie extends React.Component {
	constructor(props) {
		super(props);

		this.pageDiv = {
			border: "1px solid #cccccc",
			padding: 10,
		};

		this.pageTitle = props.pageTitle;
		this.pageName = props.pageName;
		if (this.pageName == undefined) {
			this.pageName = this.section;
		}

		this.options = [{ value: "All", label: "All" }];

		this.selectRef = React.createRef();

		this.state = {
			testo: "",
			menuBackground: "#ffffff",
			menuItemColor: "#000000",
			fontSize: 50,
			fontBold: false,
			logoPicture: "",
			logoMargin: 0,
			titleColor: "#000000",
			titleSize: 18,
			isLoading: false,
			addElementVisible: false,
			waitDialogVisible: false,
			selectPdfDatesVisible: false,
			fusioneEnabled: false,
			insegnanti: [],
			gruppiInsegnantiComplete: [],
			mailCompaniesList: [],
			reportPeriod: "",
			waitDialogFileVisible: false,
			fileReady: false,
		};

		this.grid = 2;
		this.tableRef = React.createRef();

		this.pdfElements = [];

		this.insegnanti = [];
		this.gruppiInsegnantiComplete = [];
		this.pageTitle = "Materie";
		this.brokerId = undefined;

		const cookies = new Cookies();
		var strJson = JSON.stringify({ list: [] });
		cookies.set("checksList", strJson, { path: "/" });
		this.sendMailRef = React.createRef();
		this.sendNotificationRef = React.createRef();

		this.state = {};
	}

	async reload() {
		const cookies = new Cookies();
		const username = cookies.get("username", { path: "/" });
		const token = cookies.get("token", { path: "/" });

		this.materie = await getMaterie(username, token);

		this.setState({
			materie: this.materie,
			isLoading: false,
		});
	}

	async componentDidMount() {
		await this.reload();
	}

	render() {
		var headCells = [
			//  { id: '__', numeric: false, disablePadding: true, label: '' },
			{ id: "materia", numeric: false, disablePadding: true, label: "Materia" },
			{ id: "note", numeric: false, disablePadding: true, label: "Note" },
			{ id: "_", numeric: true, disablePadding: false, label: "" },
		];

		this.searchCols = ["nome", "cognome", "materia", "mail"];

		const cookies = new Cookies();

		this.tableRef.current && this.tableRef.current.clearSearch();

		if (!this.state.materie) return <div />;

		return (
			<div id={Math.random()}>
				<LoadingOverlay
					active={this.state.isLoading}
					styles={{
						content: base => ({
							position: "relative",
							width: "100%",
							top: "200px",
						}),
					}}
					spinner
					text={"Loading your content..."}
				>
					<PageTitle
						title={this.pageTitle}
						button="NUOVO"
						onClick={() => {
							window.location.href = "/#/app/addMateria";
						}}
						onSecondClick={() => {
							this.setState({
								fusioneEnabled: true,
							});
						}}
					/>

					<Table
						searchValue={""}
						id={Math.random()}
						headCells={headCells}
						searchCols={this.searchCols}
						rows={this.state.materie}
						onEventClick={row => {
							cookies.set("currentMateria", row, { path: "/" });
							window.location.href = "/#/app/editMateria";
						}}
						onDelete={async id => {
							if (window.confirm("Sei sicuro di voler eliminare la materia?") == false) return;

							const cookies = new Cookies();
							const username = cookies.get("username", { path: "/" });
							const token = cookies.get("token", { path: "/" });
							await deleteMateria(username, token, id);
							this.reload();
						}}
						onElementCheck={async companyId => {
							const cookies = new Cookies();

							var json = cookies.get("checksList", { path: "/" });
							var checksList = json.list;
							var index = checksList.indexOf(companyId);
							if (index != -1) checksList.splice(index, 1);
							else checksList.push(companyId);

							cookies.set("checksList", JSON.stringify({ list: checksList }), { path: "/" });
						}}
					/>

					<WaitDialog show={this.state.waitDialogVisible} key={Math.random()} index={this.state.index} />
				</LoadingOverlay>
			</div>
		);
	}
}
